<div class="row h-100 w-100 m-0">

<div class="image-width p-0 " style="z-index: 3;">
  <div class="image-side"></div>
</div>

<form class="header-width"  [formGroup]="idSendForm" (submit)="login()">
  <div  class="d-flex flex-column justify-content-center text-center m-step-wrapper1 container header-zone">
    <div class="d-flex flex-column mt-md-0 login-page-padding-top">
      <!--title-->
      <div class="mb-4 text-md-right text-center mr-md-3 mr-sm-1">
        <h1 class="app-title-xxlarge mt-1">{{ 'login.title'|translate}}</h1>
      </div>
      <!--body-->
      <div class="row justify-content-lg-start justify-content-md-start justify-content-sm-center justify-content-center mb-4 mx-md-0 mx-4 wrap-login-page">
        <div class="d-flex justify-content-center justify-content-md-start text-center text-md-right sub-title">
          <inner-tooltip [qTitle]="'login.body'|translate"
          [text]="'login.body'|translate"
          class="m-start-tooltip app-title-small-blue"></inner-tooltip>		
        </div>
        
        <!--text field-->
        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-md-0 mb-4 input-wrapper">
          <app-animated-input formControlName="id" placeholder="{{ 'USER_DETAILS.Q2.PH1' | translate }}" [animatedLabel]="true" [maxLength]="9"></app-animated-input>
          <label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="idSendForm.controls['id'].errors?.required && submitted">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
          <label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="!idSendForm.controls['id'].errors?.required && (idSendForm.get('id').hasError('numbers')) && submitted">{{ 'login.errors.id-invalid' | translate }}</label>
          <label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="!idSendForm.controls['id'].errors?.required && !idSendForm.get('id').hasError('numbers') && (idSendForm.get('id').hasError('invalidId')) && submitted">{{ 'login.errors.id-bikoret' | translate }}</label>
        </div>
      </div>
      <!--send button-->
      <div class="d-flex justify-content-md-end justify-content-center mt-5">
        <button type="submit" class="app-button" [ngClass]="{'button-primary': idSendForm.valid, 'button-primary-disabled': !(idSendForm.valid)}">{{"COMMON.PROCEED"|translate}}</button>
      </div>
    </div>
  </div>
</form>
</div>

<router-outlet></router-outlet>


// WEBPACK FOOTER //
// ./src/app/login/login-page/login-page.component.html